import { saveState, preloadState } from 'lib/formStorage';
import eventbriteActionTypes from 'constants/eventbriteConstants';
import formActionTypes from 'constants/formConstants';

const initialValues = {
  venue: {
    full_address: '',
    state: { name: '', code: '' }
  },
  prices: [{}],
  links: [],
  artists: [{}],
  open_house: {},
  pricing_type: 'free',
  tags: [],
  new_tag: '',
  show_plugin: true,
  quick_form: true,
  online: false,
  time_zone: {
    value: getBrowserTimeZone()
  }
};

export function getInitialFormValues(currentFormValues = {}, config) {
  let values = {};
  if (Object.keys(currentFormValues).length > 0) {
    Object.assign(values, initialValues, currentFormValues);
  } else {
    Object.assign(values, initialValues, preloadState('formState'));
  }

  if (!config.quick_form_enabled) { values.quick_form = false };
  if (!values.uuid) { values.uuid = config.new_uuid; }
  if (!values.currency) { values.currency = config.default_currency; }
  if (!values.venue) { values.venue = initialValues.venue; }

  if (!values.pricing_type) { values.pricing_type = initialValues.pricing_type; }

  return { values };
}

export default function formLocalStorageReducer(state, action) {
  switch(action.type) {
    case eventbriteActionTypes.FETCH_EVENTBRITE_EVENT_SUCCESS:
      return Object.assign(state, { values: {...initialValues, ...state.values, ...action.payload } });
    case formActionTypes.ON_BLUR:
    case formActionTypes.ON_FOCUS:
      saveState({ formState: state.values });
      return state;
    default:
      return state;
  }
}

function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch(e) {
    return 'Europe/London';
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/formLocalStorageReducer.js